export const logout = () => {
  window.Beacon?.('logout');
};
